import { UrlPay, UrlPDFChristmas } from '../../Url'

export default {
    namespaced: true,

    state: {
        cardFiltered: 0,
        messageChristmas: {
            message: '',
            note: '',
            logo: null,
            firm: null,
        },
        loadingStatus: false,
    },
    mutations: {
        fillCard(state, param) {
            state.cardFiltered = param
        },
        loadingStatus(state, newLoadingStatus) {
            state.loadingStatus = newLoadingStatus
        },
    },
    actions: {
        fillCard: ({ commit }, param) => {
            commit('fillCard', param)
        },
        sendData: ({ commit, rootState }, platform) => {
            if (rootState.christmas.messageChristmas.message) {
                commit('loadingStatus', true)
                const cardFilter = rootState.cards.card.filter(
                    (cardId) => cardId.id === rootState.christmas.cardFiltered
                )
                const pay = {
                    donation:
                        rootState.formPay.FormPaySender.donation *
                        rootState.formPay.FormPaySender.quantity,
                    currency: 'CLP',
                    payment_platform: platform,
                    img: cardFilter[0].image,
                }

                fetch(UrlPay, {
                    method: 'POST',
                    body: JSON.stringify(pay),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }).then((res) => {
                    commit('loadingStatus', false)
                    if (res.ok) {
                        res.text()
                            .then(function (obj) {
                                let objNew = JSON.parse(obj)
                                localStorage.sessionPay = JSON.stringify(objNew)
                                localStorage.data = JSON.stringify(rootState)
                                localStorage.cardFiltered = JSON.stringify(
                                    cardFilter
                                )

                                if (objNew.paymentPlatformName === 'khipu') {
                                    window.location.replace(objNew.ref)
                                } else if (
                                    objNew.paymentPlatformName === 'webpay'
                                ) {
                                    document.write(objNew.ref)
                                    document.close()
                                } else {
                                    console.log(
                                        'No se ha identificado la plataforma de pago.'
                                    )
                                }
                            })
                            .catch((error) => console.error('Error:', error))
                    }
                })
            } else {
                alert('el mensaje no puede estar vacio')
            }
        },
        cotization: ({ rootState, commit }) => {
            const cardFilter = rootState.cards.card.filter(
                (cardId) => cardId.id === rootState.christmas.cardFiltered
            )
            if (rootState.christmas.messageChristmas.message) {
                const data = {
                    store: rootState,
                    card: cardFilter,
                }
                commit('loadingStatus', true)
                fetch(UrlPDFChristmas, {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }).then((res) => {
                    commit('loadingStatus', false)
                    return window.location.replace('./')
                })
            } else {
                alert('el mensaje no puede estar vacio')
            }
        },
    },
    getters: {},
}
